import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./guards";
import { PasswordForgotComponent } from "./password/password-forgot/password-forgot.component";
import { PasswordResetComponent } from "./password/password-reset/password-reset.component";
import { ClarionLoginComponent } from "./login/clarion_login/clarion_login.component";

const appRoutes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./main-container/main-container.module").then(
        (m) => m.MainContainerModule,
      ),
    canActivate: [AuthGuard],
  },
  { path: "de", redirectTo: "" },
  { path: "clarionlogin", component: ClarionLoginComponent },
  { path: "login", component: LoginComponent },
  { path: "password-forgot", component: PasswordForgotComponent },
  { path: "password-reset", component: PasswordResetComponent },
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
